const initPhotoUpload = () => {
  const btnPhotoUploads = document.querySelectorAll('.btn-photo');
  if (btnPhotoUploads) {
    btnPhotoUploads.forEach((btnPhotoUpload) => {
      btnPhotoUpload.addEventListener('change', (event) => {
        const angle = btnPhotoUpload.dataset.angle
        const photoLabels = document.querySelectorAll(`[data-angle=${angle}]`);
        photoLabels.forEach((photoLabel) => {
          photoLabel.classList.remove("btn-outline-green");
          photoLabel.classList.add("btn-grey");
        });
      });
    });
  };
  // For answers edit page
  const btnPhotoAnswer = document.querySelector('.btn-photo-answer')
  if (btnPhotoAnswer) {
    const photoLabel = document.querySelector('.btn-photo-label');
    btnPhotoAnswer.addEventListener('change', (event) => {
      displayPreview(btnPhotoAnswer);
      photoLabel.classList.remove("btn-outline-green");
      photoLabel.classList.add("btn-grey");
    })
  }
}

const displayPreview = (input) => {
  if (input.files) {
    const photoPrev = document.querySelector(".js-photo-preview");
    const photoPrevPhotosContainer = document.querySelector(
      ".js-photo-section-notes-preview"
    );

    Array.from(input.files).forEach((file) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img_tag = document.createElement('img');
        img_tag.classList.add("note-uploaded-photo");
        img_tag.src =
          event.currentTarget.result;
        photoPrevPhotosContainer.insertAdjacentElement('beforeend', img_tag)
      };
      reader.readAsDataURL(file);
    })

    photoPrev.classList.remove("d-none");
    const textPrompt = document.querySelector(".js-prompt");
    textPrompt.innerText = 'Please press "Submit Notes & Photos" Button';
    textPrompt.classList.add('highlight');
  }
}

export { initPhotoUpload };
